import localStorageIds from '../constants/localStorageIds'
import { USER_ADDONS } from '../constants/userAddons'
import localStorageHelper from './localStorageHelper'

const isOrgAddonsValid = (allowedAddons) => {
  const { ALL } = USER_ADDONS
  if (allowedAddons === ALL || !allowedAddons) return true

  const { localStorageValue: selectedOrg } = localStorageHelper(localStorageIds.SELECTED_ORG)
  const { addons } = selectedOrg || {}

  if (!addons) return false

  return addons.some((addon) => allowedAddons.includes(addon))
}

export default isOrgAddonsValid
